import { A as AutoScroll } from './embla-carousel-auto-scroll.esm-7BmXHxKm.js';
import { L as LoopingCarousel } from './looping-carousel-D5vI9_DG.js';
import './embla-carousel.esm-CCUHK2kO.js';

class USPTicker extends LoopingCarousel() {
  alwaysInit = true;
  emblaOptions = {
    loop: true,
    align: 'start',
    dragFree: true,
    direction: document.dir || 'ltr',
    watchSlides: false,
  };

  get emblaPlugins() {
    return [
      AutoScroll({
        startDelay: 0,
        stopOnInteraction: false,
        stopOnMouseEnter: true,
        speed: Number(this.viewport.dataset.speed) || 1,
      }),
    ];
  }

  onInit(embla) {
    embla.plugins().autoScroll.play();
  }
}

customElements.define('usp-ticker', USPTicker);
